<div class="ops-input-container" [class.disabled]="isDisabled">
  <label
    *ngIf="label"
    for="{{ formName }}"
    class="ops-input-label"
    [class.invalid]="showError && !isPreview"
  >
    {{ label }} <span *ngIf="mandatory">*</span>
  </label>

  <div *ngIf="isPreview" class="ops-input preview">
    <span *ngIf="decimalValue">{{ value | number }}</span>
    <span *ngIf="!decimalValue">{{ value }}</span>
  </div>

  <div class="input-group">
    <div (click)="fixFocus()" class="before-icon" *ngIf="beforeIcon">
      <img [src]="beforeIcon" />
    </div>
    <input
      *ngIf="!isPreview && !decimalValue"
      [attr.id]="formName"
      [attr.type]="resolveInputType(type)"
      [attr.placeholder]="placeholder"
      [disabled]="isDisabled"
      [class.invalid]="showError && !isPreview"
      [class.password-view]="passwordView"
      [(ngModel)]="value"
      (focus)="onFocus($event)"
      (blur)="onBlur($event)"
      (click)="onClick($event)"
      (mousedown)="onMouseDown($event)"
      (mouseup)="onMouseUp($event)"
      (keydown)="onKeydown($event)"
      (paste)="onPaste($event)"
      (input)="onInputChange($event)"
      name="{{ formName }}"
      [autofocus]="setFocus"
      class="ops-input"
    />

    <div class="after-icon" (click)="onSwitchPassword()" *ngIf="passwordView">
      <img *ngIf="passwordVisible" src="assets/password-hide-icon.svg" />
      <img *ngIf="!passwordVisible" src="assets/password-show-icon.svg" />
    </div>
  </div>

  <input
    *ngIf="!isPreview && decimalValue"
    [attr.id]="formName"
    [attr.type]="resolveInputType(type)"
    [attr.placeholder]="placeholder"
    [disabled]="isDisabled"
    [class.invalid]="showError && !isPreview"
    value="{{ value }}"
    (focus)="onFocus($event)"
    (blur)="onBlurNumeric($event.target.value)"
    (click)="onClick($event)"
    (input)="onAmountChange($event.target.value)"
    name="{{ formName }}"
    [autofocus]="setFocus"
    class="ops-input"
    nOpsNumber
  />

  <span *ngIf="showNoteText" class="ops-input-note">{{ noteText }}</span>

  <div *ngIf="showError && errorMessage && !isPreview" class="ops-input-error">
    {{ errorMessage }}
  </div>
</div>
